import { call, put, takeLatest } from 'redux-saga/effects'

import { sagaGet } from '../../fetch/index'
import { sagaLogoutUnauthorizedUser } from '../logout'
import { sagaHandleError, BadResponseError } from '../../helpers'
import { API_PUBLISHERS_REPORT } from '../../urls'
import {
  FETCH_PUBLISHERS_REPORT_REQUEST,
  FETCH_PUBLISHERS_REPORT_SUCCESS,
} from '../../stores/report/publishers'

const requestConfig = { headers: { Accept: 'application/json' } }

// format API request to use querysStrings
const InsertQueryStrings = (url, start, end) =>
  `${url}?createdGte=${start}&createdLte=${end}`

export function* fetchReport({ payload }) {
  const { startDate, endDate } = payload

  try {
    const response = yield call(
      sagaGet,
      InsertQueryStrings(API_PUBLISHERS_REPORT, startDate, endDate),
      requestConfig
    )

    if (response.status === 401 || response.status === 403)
      return yield call(sagaLogoutUnauthorizedUser)
    if (response.status === 404) return
    if (response.status !== 200) throw new BadResponseError(response)

    const data = yield response.json()

    yield put({ type: FETCH_PUBLISHERS_REPORT_SUCCESS, payload: data })
  } catch (err) {
    yield call(sagaHandleError, err)
  }
}

function* ReportSaga() {
  yield takeLatest(FETCH_PUBLISHERS_REPORT_REQUEST, fetchReport)
}

export default ReportSaga



// WEBPACK FOOTER //
// ./src/sagas/report/fetchPublishersReports.js